'use client';

import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

import { Modal, ModalButton, BaseModalContent } from '@/components/modal';
import { useEnvContext } from '@/app/providers';

type DefectModalProps = {
  isModalOpen: boolean;
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  onCancel?: () => void;
};

export const DefectModal = ({
  isModalOpen = false,
  setIsModalOpen,
  onCancel,
}: DefectModalProps) => {
  const environment = useEnvContext();
  const [session, setSession] = useState('');

  function closeModal() {
    setIsModalOpen(false);
    if (onCancel) {
      onCancel();
    }
  }

  function openModal() {
    setIsModalOpen(true);
  }

  useEffect(() => {
    setSession(window.sessionStorage.getItem('sessionId') || '');
  }, [isModalOpen]);

  return (
    <Modal
      heading="How to report a bug"
      isModalOpen={isModalOpen}
      openModal={openModal}
    >
      <BaseModalContent
        buttonComponent={
          <ModalButton
            variant="primary"
            onClick={closeModal}
          >
            Ok
          </ModalButton>
        }
      >
        <div className="m-5">
          <span className="mt-5 font-semibold">
            Environment: <a>{environment.env}</a>
            <br />
            Session ID: <a>{session}</a>
          </span>
          <ol className="mb-5 mt-5 list-inside list-decimal">
            <li>
              Open the shared{' '}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://eu001-sp.shell.com/:x:/r/sites/SPO003123/OKR/PSAu%20Public%20Website/Testing%20Artifacts/Single%20Gas/BusinessUATDefects_SingleGas.xlsx?d=w2df93b89a8cb48c8b8c4e769c5475923&csf=1&web=1&e=mKCch0"
              >
                DEFECT spreadsheet{' '}
              </a>
            </li>
            <li>Search to see if your defect has already been reported</li>
            <li>
              If its a new defect then continue below, OTHERWISE please add your
              session ID to the existing defect. This will help with more data
              captured.
            </li>
            <li>
              Ensure you are in the correct environment{' '}
              <a href="https://singlegas.b2c-public-website-dev.powershop.com.au/">
                single gas -
                https://singlegas.b2c-public-website-dev.powershop.com.au
              </a>
              - not all features exist in all environments
            </li>
            <li>
              In spread sheet record the steps taken to produce bug - try to
              capture specific steps and inputs e.g. Address used, plan
              selected, what you clicked on
            </li>
            <li>Write down the error message (if there is one)</li>
            <li>Take screenshots (if that helps)</li>
            <li>Record your session ID from above in the spreadsheet</li>
            <li>
              Any issues with this method please reach out to someone from the
              Amarok team
            </li>
            <li>Thank you!</li>
          </ol>
        </div>
      </BaseModalContent>
    </Modal>
  );
};
